const form = {

	init() {

		// Wanneer begindatum verandert, controleer dan of deze niet overlapt met een bestaande salaris
		$('#Begindatum').change(function(e) {
			e.preventDefault();
			if ($('#Begindatum').val() != '') {
				$.getJSON(window.app.ajaxPath + $('#form-aopercentage').data('werknemer_melding_id') + '/' + $('#form-aopercentage').data('aopercentage_id') + '/duplicate-check/' + $('#Begindatum').val() + '/' + $('#form-aopercentage').data('aopercentage_id') + '/', function(data) {
					if (data != false) {
						// Er is een overlappend salaris
						if (!$('#form_suggestion').is(':visible')) {
							$('#form_suggestion').hide().removeClass('d-none').fadeIn();
							$('#form_continue').hide();
						}
						$('.gevonden-aopercentages *').remove();
						$.each(data, function(index, val) {
							var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + val.aopercentage + '</td><td>' + val.action + '</td></tr>';
							$('.gevonden-aopercentages').append(tr);
						});
					} else {
						// Er is nog geen overlappend salaris
						form.hideFormSuggestion();
					}
				});
			}
		});
		$('#Begindatum').trigger('change');

	},

	// Verberg het blok met als deze zichtbaar is
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	}

};

export default form;
